<template>
  <tr style="cursor:pointer;" @dblclick="show()">
    <td>{{ item.id }}</td>
    <td>{{ item.name }}</td>
    <td>{{ item.email }}</td>
    <td>{{ item.verification_status | verificationStatus }}</td>
    <td>{{ formDateTimeSec(item.created_at) }}</td>
    <td>
      <template v-if="item.social_network_accounts.length !== 0">
        {{ item.social_network_accounts[0].link }}
      </template>
    </td>
    <td>{{ item.referral_programs[0].referral_category.name }}</td>
    <td>
      <template v-if="item.accounts.length !== 0">
        {{ item.accounts[0].value }}
      </template>
    </td>
    <td>{{ item.referral_programs[0].percent }}</td>
    <td>{{ item.referrals_count }}</td>
    <td style="display:flex; align-items: center; gap:10px;">
      {{ shortWord(item.fingerprints[0]?.key) }}
      <v-icon
        v-if="item.fingerprints[0]?.key"
        style="cursor: pointer"
        small
        @click="copyID(item.fingerprints[0]?.key)"
      >
        content_copy
      </v-icon>
    </td>
    <td>{{ item.accounts[0].withdrawal }}/{{ item.accounts[0].replenishment }}</td>
    <td>{{ item.replenishment_blocked_at }}</td>
    <td class="icon-td" style="display: flex; flex-direction: column; align-items: center; gap: 5px">
      {{ replenishmentStatus }}
      <input
        v-model="replenishmentBlock"
        class="icon"
        type="checkbox"
        style="accent-color: #FFC107"
      >
    </td>
    <td class="icon-td">
      <input
        v-model="withdrawalBlock"
        class="icon"
        type="checkbox"
        style="accent-color: #FFC107"
      >
    </td>
    <td class="icon-td">
      <input
        v-model="isDisabled"
        class="icon"
        type="checkbox"
        style="accent-color: #FFC107"
      >
    </td>
    <td class="icon-td">
      <v-icon small @click="show()">fas fa-list</v-icon>
    </td>
  </tr>
</template>

<script>
import { updateUser, updateUserRole } from '../../../../../api/user'
import VueMixin from '@/components/VueMixin.vue'

export default {
  name: 'UserItem',
  filters: {
    verificationStatus (value) {
      return value ? 'Да' : 'Нет'
    }
  },
  mixins: [VueMixin],
  props: {
    item: {
      id: '',
      name: '',
      email: '',
      social_network_accounts: {
        link: ''
      },
      account: {
        value: ''
      }
    }
  },
  data () {
    return {
      replenishmentStatus: ''
    }
  },
  computed: {
    isDisabled: {
      get () {
        return this.item.roles.length === 0
      },
      set (newValue) {
        this.item.roles = newValue ? [] : ['user']
        updateUserRole(this.item.id, this.item.roles).then()
      }
    },
    withdrawalBlock: {
      get () {
        return this.item.is_permanent_blocking_withdrawal
      },
      set (newValue) {
        updateUser(this.item.id, { is_permanent_blocking_withdrawal: newValue })
          .then(this.$emit('update-table'))
      }
    },
    replenishmentBlock: {
      get () {
        if (this.item.replenishment_block_status === 0) {
          this.replenishmentStatus = 'Нет'
          return false
        }
        if (this.item.replenishment_block_status === 1) {
          this.replenishmentStatus = '30 мин'
          return true
        }
        if (this.item.replenishment_block_status === 2) {
          this.replenishmentStatus = 'Постоянная'
          return true
        }
      },
      set (newValue) {
        this.item.replenishment_block_status = newValue ? 2 : 0
        this.item.is_permanent_blocking_replenishment = newValue
        updateUser(this.item.id, { is_permanent_blocking_replenishment: this.item.is_permanent_blocking_replenishment })
          .then(this.$emit('update-table'))
      }
    }
  },
  methods: {
    show () {
      this.$router.push(`/users/${this.item.id}`)
    },
    shortWord (item) {
      if (item)
        return item.length > 10 ? `${item.slice(0, 10)}...` : item
    },
    copyID (id) {
      navigator.clipboard.writeText(id)
        .then(() => {
          this.$emit('copied')
        })
    }
  }
}
</script>

<style scoped>
    .icon-td {
        text-align: center
    }

    .icon-td .icon {
        cursor: pointer;
        display: inline-block;
        width: 17px;
        height: 17px;
    }
</style>
